const hostname = "qy.nxtt.org.cn";
const domain = process.env.NODE_ENV === `development` ? "192.168.40.78" : `.${hostname}`;
const projectHosts = {
  web: 'web',  // pc主站
  admin: 'admin',  // 交易系统
  trade: 'admin',
  data: 'data',  // dataServer
  cms: 'cms',  // 楼层
  shenbao: 'shenbao', // 申报
  qxt: 'qxt',  // 企校通
  service: 'service', // 科技服务
  seller: 'seller' // 卖家中心
}
export {
  hostname,
  domain,
  projectHosts
};